import { AutomatedTextActions } from './partials/automatedTextTemplate'
import { DocketwiseSettingsActions } from './partials/docketwise'
import { EngagementLetterActions } from './partials/engagementLetter'
import { GenericModelSettingsActions } from './partials/genericModel'
import { InvoicedSettingsActions } from './partials/invoiced'
import { LegalCasePartySliderSettingsActions } from './partials/legalCasePartySlider'
import { LegalCasesSettingsActions } from './partials/legalCases'
import { MiscSettingsActions } from './partials/misc'
import { MultifactorAuthenticationSettingsActions } from './partials/multifactorAuthentication'
import { OtherDocketEntriesSettingsActions } from './partials/otherDocketEntries'
import { RecordsSettingsActions } from './partials/records'
import { SettingsSharedActions } from './partials/shared'
import { TimezoneSettingsActions } from './partials/timezone'
import { TmetricSettingsActions } from './partials/tmetric'
import { TwilioSettingsActions } from './partials/twilio'
import { UserAccessSettingsActions } from './partials/usersAccess'
import { UserSettingsActions } from './partials/user'
import { WorkflowSettingsActions } from './partials/workflows'

export const SettingsActions = {
  ...AutomatedTextActions,
  ...DocketwiseSettingsActions,
  ...EngagementLetterActions,
  ...GenericModelSettingsActions,
  ...InvoicedSettingsActions,
  ...LegalCasePartySliderSettingsActions,
  ...LegalCasesSettingsActions,
  ...MiscSettingsActions,
  ...MultifactorAuthenticationSettingsActions,
  ...OtherDocketEntriesSettingsActions,
  ...RecordsSettingsActions,
  ...SettingsSharedActions,
  ...TimezoneSettingsActions,
  ...TmetricSettingsActions,
  ...TwilioSettingsActions,
  ...UserAccessSettingsActions,
  ...UserSettingsActions,
  ...WorkflowSettingsActions,
}
